import React from 'react';
import { PropInfo, CodeExample, SnackbarProps } from '@cimpress/react-components';
import SnackbarCode from '!raw-loader!./snackbar.jsx';
import SnackbarDemo from './snackbar.jsx';
import ComponentDoc from '../../shared/TabbedComponentDoc';

const SnackbarDocs = () => {
  const propInfos: PropInfo<SnackbarProps>[] = [
    {
      name: 'show',
      type: 'boolean',
      default: 'false',
      description: 'Controls whether or not the snackbar is hidden',
    },
    {
      name: 'status',
      type: 'string',
      default: '"danger"',
      description: 'One of the four contextual styles: info, success, warning, or danger',
    },
    {
      name: 'delay',
      type: 'number',
      default: '',
      description: `How long to display the snackbar before autodismissing, in milliseconds.
        If not provided or if a falsy delay is given, the snackbar must be manually dismissed`,
    },
    {
      name: 'children',
      type: 'node',
      default: '',
      description: 'Snackbar renders any children given to it as contents on the right-hand side of the snackbar',
    },
    {
      name: 'onHideSnackbar',
      type: 'function',
      default: '',
      description: 'Callback function to be called when the snackbar auto-dismisses or is closed',
    },
  ];

  return (
    <ComponentDoc name="Snackbar" propInfos={propInfos}>
      <SnackbarDemo />
      <CodeExample code={SnackbarCode} />
    </ComponentDoc>
  );
};

export default SnackbarDocs;
